@if (productId; as string) {
    <app-product-address-link-list-edit-widget
        [autoFocusSearch]="false"
        [productId]="productId"
    />
} @else {
    <div class="flex justify-center items-center choose-ngifloader-splitter h-full w-full min-h-[400px]">
        <div class="shine">
            <h3>{{ 'product.product-choose' | translate }}</h3>
        </div>
    </div>
}
